<template>
  <div style="background: black;">
    <iframe style="display: block; margin: auto;" width="960px" height="560px" scrolling="0" frameborder="0" src="https://mapletone.com/leifpark/LEIF_park_GAME/index.html"></iframe>
  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
